import { render } from "./Like.vue?vue&type=template&id=39479e4d&ts=true&lang=pug"
import script from "./Like.vue?vue&type=script&setup=true&lang=ts"
export * from "./Like.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__